import React from 'react';
import { makeStyles, Button, Grid, Typography } from '@material-ui/core';
import { PropTypes } from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AddCircleOutlineSharpIcon from '@mui/icons-material/AddCircleOutlineSharp';
import { TableHeaderPagination } from '~/modules/resourcing/common/components';

export const useTitleStyles = makeStyles(theme => ({
  root: {
    margin: 0
  },
  title: {
    alignContent: 'center',
    padding: theme.spacing(0, 3, 0, 0),
    fontWeight: theme.typography.fontWeightMedium
  },
  resourceCount: {
    alignContent: 'center',
    color: theme.palette.text.secondary,
    fontWeight: theme.typography.fontWeightRegular
  },
  closedExpansionPanel: {
    display: 'flex',
    justifyContent: 'space-between',
    width: `calc(100% - ${theme.spacing(15)}px)`
  },
  button: {
    padding: 0
  }
}));

const noop = () => ({});
const addCircleIcon = <AddCircleOutlineSharpIcon />;

export const TaskEstimateTitle = ({
  expanded = false,
  assignmentCount = 0,
  assignmentWithResourceCount = 0
}) => {
  const classes = useTitleStyles();

  return (
    <Grid container className={classes.root}>
      <Typography variant="subtitle1" className={classes.title}>
        <FormattedMessage id="taskResourceEstimates.resources" />
      </Typography>
      {expanded ? (
        <div className={classes.closedExpansionPanel}>
          {/* Todo: Add + functionality */}
          <Button
            color="primary"
            startIcon={addCircleIcon}
            className={classes.button}
          >
            <FormattedMessage id="taskResourceEstimates.resource" />
          </Button>
          {/* Update pagination functionality.  */}
          {assignmentCount > 0 && (
            <TableHeaderPagination
              currentPage={1}
              currentPageRowCount={5}
              pageSize={10}
              setCurrentPage={noop}
            />
          )}
        </div>
      ) : (
        // Todo: Update to show actual resource count
        <Typography variant="subtitle2" className={classes.resourceCount}>
          <FormattedMessage
            id="taskResourceEstimates.resourceCount.count"
            values={{
              count:
                assignmentCount === assignmentWithResourceCount
                  ? assignmentCount
                  : `${assignmentWithResourceCount}/${assignmentCount}`
            }}
          />
        </Typography>
      )}
    </Grid>
  );
};

export default TaskEstimateTitle;

TaskEstimateTitle.propTypes = {
  expanded: PropTypes.bool,
  assignmentCount: PropTypes.number,
  assignmentWithResourceCount: PropTypes.number
};
